import SimpleTable from 'components/Tables/SimpleTable';
import React from 'react';
import theme from 'source/theme';

const columns = [
  { title: 'Nome', field: 'name', label: 'Nome', key: 'name' },
  { title: 'CAS', field: 'cas', label: 'CAS', key: 'cas' },
  { title: 'EC', field: 'ec', label: 'EC', key: 'ec' },
  { title: 'SVHC descr.', field: 'svhc_description', label: 'SVHC descrição', key: 'svhc_description' },
  { title: 'SVHC inclusão', field: 'svhc_inclusion_reasons', label: 'SVHC inclusão', key: 'svhc_inclusion_reasons' },
  { title: 'SVHC data', field: 'svhc_inclusion_date', label: 'SVHC data inclusão', key: 'svhc_inclusion_date' },
  { title: 'Restrições descr.', field: 'restriction_descriptions', label: 'Restrições descrição', key: 'restriction_descriptions' },
  { title: 'Restrições entrada', field: 'restriction_entry_numbers', label: 'Restrições entrada', key: 'restriction_entry_numbers' },
  { title: 'Autorização data', field: 'authorization_dates', label: 'Autorização data limite', key: 'authorization_dates' },
  { title: 'Autorização isenções', field: 'authorization_exempted_uses', label: 'Autorização isenções', key: 'authorization_exempted_uses' }
];

export default props => {
  const { rowData, data, title } = props;
  // TODO: Solve on the backend API is not sending only ids in some cases sends Objects with full entity
  // cons rows = rowData.map(id => data[id]);
  let rows = [];
  if (typeof rowData[0] === 'number' || typeof rowData[0] === 'string') {
    rows = rowData.map(id => data[id]);
  } else {
    rows = rowData.map(obj => data[obj.substance_id]);
  }

  rows = rows.map(row => {
    if (row.restriction_entry_numbers && Array.isArray(row.restriction_entry_numbers)) {
      return {
        ...row,
        restriction_entry_numbers: (
          <div>
            {
              row.restriction_entry_numbers.map((value, index) =>
                <p key={index} style={{ backgroundColor: index % 2 ? 'lightGrey' : 'white' }}>{value}</p>
              )
            }
          </div>
        ),
        restriction_descriptions: (
          <div>
            {
              row.restriction_descriptions.map((value, index) =>
                <p key={index} style={{ backgroundColor: index % 2 ? 'lightGrey' : 'white' }}>{value === '' ? '-' : value}</p>
              )
            }
          </div>
        )
      };
    }
    return row;
  });

  return (
    <div style={{ padding: 10, backgroundColor: theme.palette.background.light }}>
      <SimpleTable columns={columns} rows={rows} title={title}/>
    </div>
  );
};
